// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3ah4G","rootSuccess":"CompleteLink_rootSuccess__1wSy8","rootFailure":"CompleteLink_rootFailure__2Lxhq","isDisabled":"CompleteLink_isDisabled__2aNB_"};